import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// FROM: https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md
export class ScrollToTop extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.object,
};

ScrollToTop.defaultProps = {
  children: {},
};

export default withRouter(ScrollToTop);
